import React, { useEffect, useCallback, useState } from 'react'
import Creatable from 'react-select/creatable'
import { IoCloseSharp } from 'react-icons/io5'
import { toast } from 'react-toastify'
import { sendMessage } from '../../Api/slack'
import './slack.css'

const SlackPopup = ({ data, setData, slackData }) => {
  const [channelsAndUsers, setChannelsAndUsers] = useState([])
  const [selectedChannelsAndUsers, setSelectedChannelsAndUsers] = useState([])
  const [note, setNote] = useState('')

  useEffect(() => {
    setChannelsAndUsers([...slackData])
  }, [channelsAndUsers, slackData])

  const sendMessageHandler = useCallback(async () => {
    if (selectedChannelsAndUsers.length > 0) {
      const channelsAndUsers = selectedChannelsAndUsers.map(
        (item) => item.value
      )
      let message = []
      if (data.meetingTag) {
        message.push(`Meeting: ${data.meetingTag}`)
      }
      // if (data?.tag?.filter((item) => item)?.length > 0) {
      //   message.push(`Tags: ${data?.tag?.filter((item) => item).join(",")}`);
      // }
      let assignee = data?.assignee
        ?.filter((item) => item.email)
        ?.map((item) => item.email)
        .join(',')
      message = `Task: ${assignee} to ${data.title} by ${data.dueDate.split('T')[0]?.split('-').join('.')}`
      const apiResponse = await sendMessage({
        channelsAndUsers: channelsAndUsers,
        message: message,
        note: note,
      })
      if (apiResponse) {
        toast.success('Task shared successfully')
      } else {
        toast.error('Some error occured')
      }
      setData(null)
    } else {
      toast.error('Please select atleast one channel or user')
    }
  }, [data, selectedChannelsAndUsers, note, setData])
  return (
    <div className='slack'>
      <div className='content'>
        <button className='close' onClick={() => setData(null)}>
          <IoCloseSharp size={22} />
        </button>
        <p>
          <img alt='' src='/assets/images/slack.png' />
          Share &quot;Task&quot; details via slack.
        </p>
        <Creatable
          options={channelsAndUsers}
          isMulti
          autoFocus
          isClearable={false}
          styles={{
            control: (base) => ({
              ...base,
              width: '400px',
              borderColor: '#000000',
              // This line disable the blue border
              boxShadow: '#000000 !important',
              '&:hover': {
                borderColor: '#000000 !important',
              },
            }),
            container: (base) => ({
              ...base,
              fontSize: '14px',
            }),
            option: (base) => ({
              ...base,
              color: 'black',
            }),
            placeholder: (base) => ({
              ...base,
              color: '#54595E',
            }),
            input: (base) => ({
              ...base,
              color: 'black',
              fontSize: '12px',
            }),
            multiValue: (base) => ({
              ...base,
              color: 'white',
              background: 'black',
              borderRadius: '5px',
            }),
            multiValueLabel: (base) => ({
              ...base,
              color: 'white',
            }),
          }}
          placeholder='Add recipient or press # for channel'
          value={selectedChannelsAndUsers}
          formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
          onChange={(e) => {
            setSelectedChannelsAndUsers([...e])
          }}
        />
        <input
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder='Add a note...'
        />
        <button className='send' onClick={sendMessageHandler}>
          Send
        </button>
      </div>
    </div>
  )
}

export default SlackPopup
